import type { AuthUser } from '../types';

/** Admin do painel (grupo XUI 1). */
export function isCmsAdminUser(user: AuthUser | null | undefined): boolean {
  return Number(user?.member_group_id) === 1;
}

/**
 * Contas de venda no CMS: sócio, master, revendedor, sub-revendedor (grupos 2, 3, 4, 6),
 * com fallback pelo campo `level`.
 */
export function isCmsSellerGroupUser(user: AuthUser | null | undefined): boolean {
  if (!user || isCmsAdminUser(user)) return false;
  const mg = Number(user.member_group_id ?? 0);
  if ([2, 3, 4, 6].includes(mg)) return true;
  const lv = String(user.level ?? '').toLowerCase();
  return ['socio', 'master', 'reseller', 'subreseller'].includes(lv);
}
